export default __webpack_public_path__ + "aa3db79644710ec2fc6daebd2778d8cd.png";